import BaseEntity from '../../base/BaseEntity.model';

export default class TramiteBeneficiarioContent extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public attributes: TramiteBeneficiarioContentAttribute[];
    constructor(public contentConfigId?: number) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.attributes = [];
    }
}

export class TramiteBeneficiarioContentAttribute extends BaseEntity {
    public tramiteBeneficiarioContentId?: number;
    public valorString?: string;
    public valorInt?: number;
    public valorBooleano?: boolean;
    public valorDate?: Date;
    public valorDoc?: any;
    public attributes?: TramiteBeneficiarioContentAttribute[];
    constructor(public name: string, public type?: string, public contentConfigAttributeId?: number) {
        super();
        this.tramiteBeneficiarioContentId = undefined;
        this.valorString = undefined;
        this.valorInt = undefined;
        this.valorBooleano = undefined;
        this.valorDate = undefined;
        this.valorDoc = undefined;
        this.attributes = [];
    }
}